function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconReplay = function SvgIconReplay(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), h("g", {
    fill: "rgba(255,255,255,0.15)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1.5
  }, h("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), h("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "none"
  })), h("path", {
    fill: "#fff",
    d: "M12.944 12.944a9.55 9.55 0 0 1 3.205-2.178 9.9 9.9 0 0 1 3.85-.766 9.7 9.7 0 0 1 5 1.351A10.1 10.1 0 0 1 28.65 15 9.74 9.74 0 0 1 30 20.02a9.63 9.63 0 0 1-1.35 5 10.17 10.17 0 0 1-3.651 3.63 9.93 9.93 0 0 1-8.628.664 10 10 0 0 1-3.064-1.894.41.41 0 0 1-.162-.344.47.47 0 0 1 .122-.342l.805-.805a.52.52 0 0 1 .323-.143.5.5 0 0 1 .363.1 7.5 7.5 0 0 0 2.4 1.492 7.8 7.8 0 0 0 2.842.525 7.65 7.65 0 0 0 3.952-1.068 8 8 0 0 0 2.883-2.883 7.84 7.84 0 0 0 0-7.9 8 8 0 0 0-2.883-2.882A7.64 7.64 0 0 0 20 12.1a7.75 7.75 0 0 0-3.043.606 8.3 8.3 0 0 0-2.56 1.693l2.218 2.218a.43.43 0 0 1 .081.5.44.44 0 0 1-.444.3h-5.767a.47.47 0 0 1-.342-.141.47.47 0 0 1-.141-.342v-5.767a.44.44 0 0 1 .3-.442.43.43 0 0 1 .5.079Z"
  }));
};
export default SvgIconReplay;